import React from "react";
import {
  AuthContextProvider,
  useAuth,
  IAuthContext,
} from "contexts/AuthContext";
import { Toaster } from "components/ui/sonner";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "components/errors/ErrorFallbackScreen";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import { FeatureFlagProvider } from "./contexts/FeatureFlagContext";
import { LayoutProvider } from "./contexts/LayoutContext";

const queryClient = new QueryClient();

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    auth: undefined! as IAuthContext,
  },
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }

  interface RouterContext {
    auth: IAuthContext;
  }
}

const InnerApp = () => {
  const auth = useAuth();

  return <RouterProvider router={router} context={{ auth }} />;
};

const App: React.FC = () => (
  <ErrorBoundary fallback={ErrorFallback}>
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <FeatureFlagProvider>
          <LayoutProvider>
            <InnerApp />
          </LayoutProvider>
          <Toaster />
        </FeatureFlagProvider>
      </AuthContextProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
